import { render } from "./MyTimetable.vue?vue&type=template&id=56ccedd0&scoped=true&ts=true"
import script from "./MyTimetable.vue?vue&type=script&lang=ts"
export * from "./MyTimetable.vue?vue&type=script&lang=ts"

import "./MyTimetable.vue?vue&type=style&index=0&id=56ccedd0&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ccedd0"]])

export default __exports__